/**
 * The composer, or — when a conflict has just closed it — the notice explaining
 * why the page changed underneath the operator. One slot, because they are
 * alternatives: the message belongs where the box they were typing in was.
 */
import { ReviewActionNotice, ReviewNoteComposer } from '../ReviewNoteComposer';
import type { useReviewDetailState } from '../useReviewDetailState';

export default function ReviewComposerSlot({ s }: { s: ReturnType<typeof useReviewDetailState> }) {
  if (!s.composer) return <ReviewActionNotice message={s.actionError} />;
  return (
    <ReviewNoteComposer
      mode={s.composer}
      note={s.note}
      onNoteChange={s.changeNote}
      noteMessage={s.noteMessage}
      actionError={s.actionError}
      submitting={s.submitting}
      onSubmit={s.submit}
      onCancel={s.closeComposer}
    />
  );
}
